export type PlaylistDisplayHubStoryType = PlaylistDisplayHubStory;
export type PlaylistDisplayHubStoriesType = PlaylistDisplayHubStory[];

export type PlaylistDisplayHubStoryResponseType = PlaylistDisplayHubStoryType;
export type PlaylistDisplayHubStoriesResponseType = PlaylistDisplayHubStoriesType;

export type PlaylistDisplayHubStoryStateType = {
  playlistDisplayHubStories: PlaylistDisplayHubStoriesType | null;
  selectedPlaylistDisplayHubStory: PlaylistDisplayHubStoryType | null;
  loading: boolean;
  error: string | null;
};

export const PLAYLIST_DISPLAY_HUB_STORY = 'playlistDisplayHubStory';
export type PLAYLIST_DISPLAY_HUB_STORY = typeof PLAYLIST_DISPLAY_HUB_STORY;

export const REQUEST_CREATE_PLAYLIST_DISPLAY_HUB_STORY = `${PLAYLIST_DISPLAY_HUB_STORY}/requestCreatePlaylistDisplayHubStory`;
export type REQUEST_CREATE_PLAYLIST_DISPLAY_HUB_STORY =
  typeof REQUEST_CREATE_PLAYLIST_DISPLAY_HUB_STORY;

export const REQUEST_DELETE_PLAYLIST_DISPLAY_HUB_STORY = `${PLAYLIST_DISPLAY_HUB_STORY}/requestDeletePlaylistDisplayHubStory`;
export type REQUEST_DELETE_PLAYLIST_DISPLAY_HUB_STORY =
  typeof REQUEST_DELETE_PLAYLIST_DISPLAY_HUB_STORY;

export const REQUEST_DUPLICATE_PLAYLIST_DISPLAY_HUB_STORY = `${PLAYLIST_DISPLAY_HUB_STORY}/requestDuplicatePlaylistDisplayHubStory`;
export type REQUEST_DUPLICATE_PLAYLIST_DISPLAY_HUB_STORY =
  typeof REQUEST_DUPLICATE_PLAYLIST_DISPLAY_HUB_STORY;

export const REQUEST_REORDER_PLAYLIST_DISPLAY_HUB_STORY = `${PLAYLIST_DISPLAY_HUB_STORY}/requestReorderPlaylistDisplayHubStory`;
export type REQUEST_REORDER_PLAYLIST_DISPLAY_HUB_STORY =
  typeof REQUEST_REORDER_PLAYLIST_DISPLAY_HUB_STORY;

export const REQUEST_GET_ALL_PLAYLIST_DISPLAY_HUB_STORIES = `${PLAYLIST_DISPLAY_HUB_STORY}/requestGetAllPlaylistDisplayHubStories`;
export type REQUEST_GET_ALL_PLAYLIST_DISPLAY_HUB_STORIES =
  typeof REQUEST_GET_ALL_PLAYLIST_DISPLAY_HUB_STORIES;

export const REQUEST_SET_SELECTED_PLAYLIST_DISPLAY_HUB_STORY = `${PLAYLIST_DISPLAY_HUB_STORY}/requestSetSelectedPlaylistDisplayHubStory`;
export type REQUEST_SET_SELECTED_PLAYLIST_DISPLAY_HUB_STORY =
  typeof REQUEST_SET_SELECTED_PLAYLIST_DISPLAY_HUB_STORY;
